<template src="./activityNewAssignments.html"></template>

<script>
import PortalFooter from "../../../Components/PortalFooter";
import SubjectsRepository from "../../../Repository/Subjects";
import SemesterRepository from "../../../Repository/Semester";
import NewExamRepository from "../../../Repository/NewExam";
import showStatus from '../../../NetworkManager/showStatus'
import apiV3 from "../../../NetworkManager/apiV3";
import { convertDate, timeStringConverter } from "../../../Services/Utils/DateTimeFormatter"

export default {
  name: "activityNewAssignments",
  components: {
    PortalFooter
  },
  props: [
    'prop_department',
    'prop_course',
    'prop_selectedSubject',
    'prop_typeDivGrpBatch',
    'prop_selectedDivision',
    'prop_selectedBatch',
    'prop_selectedGroup',
    'prop_examType'
  ],

  data() {
    return {
      blue: "#050D92",
      backgroundColor: "#E7E7FFCF",
      orange: "#FF4F1F",
      downArrow: "mdi-chevron-down",
      upArrow: "mdi-arrow-up",
      examsLoaded: true,
      isMobileView: false,
      assignedExam: [],
      selectedExamType: '',
      assignedExamDetails: {},
      academicDataTree: {},
      subjectId: [],
      filteredSubjectId: [],
      courseYears: [],
      test: {},
      showAnswersConfirmation: false,
      subjectNamesById: [],
      courseName: [],
      departments: [],
      divisionName: [],
      semestersList: [],
      divisions: [],
      departmentName: [],
      selectedDivision: "",
      course: "",
      department: "",
      allExamsDetails: [],
      selectedSemester: '',
      selectedSubject: null,
      facultySubjects: [],
      typeForDivOrGrpOrBatch: ['Division', 'Group', 'Batch'],
      typeDivGrpBatch: '',
      batches: [],
      selectedBatch: {},
      subjectGroups: [],
      selectedGroup: {},
      createShow: false,
      allExams: [],
      isShowCreate: true,
      isDisabledDelete: false,
      search: '',
      examTableHeaders: [
        {
          text: 'Name',
          value: 'title'
        },
        {
          text: 'Allowed File types',
          value: 'allowedFileTypes'
        },
        {
          text: 'Published On',
          value: 'convertedPublishedDate'
        },
        {
          text: 'Due',
          value: 'convertedDueDate'
        },
        {
          text: 'Time',
          value: 'convertedTime'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center'
        }
      ],
      onlineTests: [],
      OnlineTestHeaders: [
      {
          text: 'Conduction',
          value: 'conduction',
          align: 'center'
        },
      {
          text: 'Name',
          value: 'name',
          align: 'center'
        },
        {
          text: 'Total Marks',
          value: 'totalMarks',
          align: 'center'
        },
        {
          text: 'Passing Marks',
          value: 'passingMarks',
          align: 'center'
        },
        {
          text: 'Publish Date',
          value: 'publishDate',
          align: 'center'
        },
        {
          text: 'Test Time',
          value: 'dateTimeUTC',
          align: 'center'
        },
        {
          text: 'Duration(Mins)',
          value: 'durationInMins',
          align: 'center'
        },
        {
          text: 'Questions',
          value: 'questions',
          align: 'center'
        },
        // {
        //   text: "Co's Mapped",
        //   value: '',
        //   align: 'center'
        // },
        // {
        //   text: 'Blooms Mapped',
        //   value: '',
        //   align: 'center'
        // },
        {
          text: 'Assigned Students',
          value: 'allowedStudents',
          align: 'center'
        },
        {
          text: 'Show Answers',
          value: 'showAnswer',
          align: 'center'
        },
        {
          text: 'Analysis',
          value: 'analysis',
          align: 'center'
        },
        {
          text: '',
          value: 'actions',
          align: 'center'
        }
      ],
      filteredExams: [],
      subjectExams: [],
      showModal: false,
      examToDelete: null,
      loading: false
    };
  },
  async created() {
    this.$store.commit("liveData/set_selectedActivityName", `My Exam`);
    this.isMobileView = this.$store.getters["liveData/get_isMobileView"];
    this.semesterRepositoryInstance = new SemesterRepository(this);
    this.newExamRepositoryInstance = new NewExamRepository(this);
    this.user = this.$store.getters["user/get_user"];
    this.userData = this.$store.getters["user/get_userData"];
    this.selectedInstitute =
      this.$store.getters["instituteData/get_selectedInstitute"];
    this.selectedSemester =
      this.$store.getters["instituteData/get_selectedSemester"];
    this.subjectsRepositoryInstance = new SubjectsRepository(this);
    await this.getSemestersList();
    this.subjectId = this.userData.subjects.map((item) => item.subjectId);
    this.departments = [
      ...new Set(this.userData.subjects.map((item) => item.department))
    ];
    if (this.prop_examType) {
      this.selectedExamType = this.prop_examType
    }
    if (this.prop_department) {
      this.department = this.prop_department
      await this.selectDepartment()
    }
    if (this.prop_course) {
      this.course = this.prop_course
      await this.selectCourseYear()
    }
    if (this.prop_selectedSubject) {
      this.selectedSubject = this.prop_selectedSubject
      await this.getGroupsOfSubjects()
    }
    if (this.prop_typeDivGrpBatch) this.typeDivGrpBatch = this.prop_typeDivGrpBatch
    if (this.prop_selectedDivision) {
      this.selectedDivision = this.prop_selectedDivision
      await this.filterDivAssignments()
    }
    if (this.prop_selectedBatch?.batchName) {
      await this.getDivisionBatches()
      this.selectedBatch = this.prop_selectedBatchtimeAndDate
      await this.filterBatchAssignments()
    }
    if (this.prop_selectedGroup?.groupId) {
      this.selectedGroup = this.prop_selectedGroup
      await this.filterGroupAssignments()
    }
  },
  methods: {
    timeAndDate(isoDate, minutesToAdd) {
      const dateObj = new Date(isoDate);
      const istOffset = 5.5 * 60 * 60 * 1000;
      const istDateObj = new Date(dateObj.getTime() + istOffset);
      const date = istDateObj.toISOString().slice(0, 10);
      let startHours = istDateObj.getUTCHours();
      const startMinutes = istDateObj.getUTCMinutes();
      const startPeriod = startHours >= 12 ? "PM" : "AM";
      startHours = startHours % 12 || 12;
      const startTime = `${startHours}:${startMinutes.toString().padStart(2, "0")} ${startPeriod}`;
      istDateObj.setMinutes(istDateObj.getMinutes() + minutesToAdd);
      let endHours = istDateObj.getUTCHours();
      const endMinutes = istDateObj.getUTCMinutes();
      const endPeriod = endHours >= 12 ? "PM" : "AM";
      endHours = endHours % 12 || 12;
      const endTime = `${endHours}:${endMinutes.toString().padStart(2, "0")} ${endPeriod}`;
      return { date, timeRange: `${startTime} - ${endTime}` };
    },
    answersCheckChanged(item) {
      this.selectedItem = item;
      this.showAnswersConfirmation = true;
    },
    cancelCheckboxChange() {
        if (this.selectedItem) {
          this.selectedItem.showAnswers = false; // Revert checkbox state
        }
        this.showAnswersConfirmation = false;
        this.selectedItem = null;
      },
      async confirmCheckboxChange() {
      if (!this.selectedItem) return;

      this.showAnswersConfirmation = false;

      const examDetails = {
        status: "published",
        showAnswers: this.selectedItem.showAnswers,
        examId: this.selectedItem._id
      };

      try {
        const updatedTest = await apiV3.putRequest("/exam/updateTest", examDetails);
        if (updatedTest) {
          showStatus("Updated answers visibility successfully", 2000, "success", this);
        } else {
          showStatus("Error in updating details", 4000, "error", this);
        }
      } catch (error) {
        console.error("Error saving exam details:", error);
      }

      this.selectedItem = null;
    },
    checkIfExamRoute() {
      this.createShow = false
      console.log('this.createShow', this.createShow);
      this.onlineTests = []
      if (this.selectedExamType === 'Exams') {
        this.$router.push({
          name: 'activityMyExam'
        })
      } else {
        this.department = ''
        this.course = ''
        this.selectedSubject = null
        this.typeDivGrpBatch = ''
        this.selectedDivision = ''
        this.selectedBatch = {}
        this.selectedGroup = {}
      }
    },
    async getExams() {
      if (this.selectedExamType === 'Assignments') {
        const objToPush = {
          instituteId: this.selectedInstitute,
          semId: this.selectedSemester.semId,
          department: this.department,
          courseYear: this.course
        }
        this.allExams = await this.newExamRepositoryInstance.getExams(objToPush)
        this.allExams.map((exam) => {
          exam.convertedPublishedDate = convertDate(exam.publishDate)
          exam.convertedTime = timeStringConverter(exam.dueTime)
          exam.convertedDueDate = convertDate(exam.dueDate)
        })
      }
      this.loading = false
    },
    async getSemestersList() {
      try {
        const objToPush = {
          instituteId: this.selectedInstitute,
          semId: this.selectedSemester.semId
        };
        this.semestersList =
          await this.semesterRepositoryInstance.getDivisionsOfASemester(
            objToPush
          );
      } catch (e) {
        console.error("e", e);
      }
    },
    selectDepartment() {
      this.onlineTests = []
      this.selectedCourseYear = "";
      this.course = "";
      this.typeDivGrpBatch = ""
      this.selectedDivision = "";
      this.assignedExam = []
      this.facultySubjects = []
      this.selectedSubject = null
      this.typeDivGrpBatch = ''
      this.subjectGroups = []
      this.selectedGroup = {}
      this.filteredExams = []
      this.isShowCreate = true
      this.courseYears = this.semestersList.filter(item => item.department === this.department).map(data => data.courseYear)
      this.$store.commit("liveData/set_examDepartment", this.department);
    },
    async selectCourseYear() {
      this.onlineTests = []
      this.loading = true
      this.selectedDivision = "";
      this.typeDivGrpBatch = ""
      this.assignedExam = []
      this.facultySubjects = []
      this.selectedSubject = null
      this.typeDivGrpBatch = ''
      this.subjectGroups = []
      this.selectedGroup = {}
      this.filteredExams = []
      this.isShowCreate = true
      this.divisions = this.semestersList.filter(item => item.department === this.department && item.courseYear === this.course).map(data => data.division)
      this.$store.commit("liveData/set_examCourseYear", this.course);
      try {
        const facultySubjects = await this.subjectsRepositoryInstance.getSubjectsTaughtByAFaculty({
          uId: this.userData.uId,
          instituteId: this.selectedInstitute,
          semId: this.selectedSemester.semId,
          department: this.department,
          courseYear: this.course
        })
        this.facultySubjects = facultySubjects.subjects
      } catch (error) {
        console.error(error);
      }
      await this.getExams()
    },
    typeSelected() {
      this.onlineTests = []
      this.selectedGroup = {}
      this.selectedDivision = ""
      this.selectedBatch = ''
      this.filteredExams = []
      this.isShowCreate = true
    },
    async filterSubjectExams() {
      if (this.allExams?.length > 0) {
        this.subjectExams = await this.allExams.filter(exam => exam.subjectIds?.includes(this.selectedSubject.subjectId))
      }
      // this.allExams =
    },
    checkIsDeletable() {
      this.onlineTests.forEach(test => {
          if (
            test?.dateTimeUTC &&
            new Date(test?.dateTimeUTC) < new Date()
          ) {
            test.isDisabledDelete = true;
          }
        })
    },
    async filterDivAssignments() {
      // this.loading = true
      this.onlineTests = []
      this.isShowCreate = false;
      if (this.subjectExams?.length > 0) {
        this.filteredExams = []
        if (this.typeDivGrpBatch === 'Division') {
          const tableArray = this.subjectExams.filter(exam =>
            (exam?.division === this.selectedDivision) && (exam.uId === this.userData.uId || exam.uId === undefined) && (!exam.batch || exam.batch === '')
          ).reverse();
          this.filteredExams = tableArray
        }
      } else if (this.selectedExamType === 'Online Test') {
        const { exams = [] } = await apiV3.getRequest('/exam/all', {
          category: 'quick_exam',
          facultyId: this.userData.uId,
          subjectId: this.selectedSubject.subjectId,
          semId: this.selectedSemester.semId,
          division: this.selectedDivision
        })
        this.onlineTests = exams
        // this.loading = false
        this.checkIsDeletable()
      }
      this.createShow = true
    },
    async filterGroupAssignments() {
      // this.loading = true
      this.onlineTests = []
      this.isShowCreate = false;
      if (this.subjectExams?.length > 0) {
        this.filteredExams = []
        if (this.typeDivGrpBatch === 'Group') {
          this.filteredExams = this.subjectExams.filter(exam => (exam?.assignedGroupForSubject?.groupName === this.selectedGroup.groupName) && (exam.uId === this.userData.uId || exam.uId === undefined)).reverse()
        }
      } else if (this.selectedExamType === 'Online Test') {
        const { exams = [] } = await apiV3.getRequest('/exam/all', {
          category: 'quick_exam',
          facultyId: this.userData.uId,
          subjectId: this.selectedSubject.subjectId,
          semId: this.selectedSemester.semId,
          groupId: this.selectedGroup.groupId
        })
        this.onlineTests = exams
        // this.loading = false
        this.checkIsDeletable()
      }
      this.createShow = true
    },
    async filterBatchAssignments() {
      // this.loading = true
      this.onlineTests = []
      this.isShowCreate = false;
      if (this.subjectExams?.length > 0) {
        this.filteredExams = []
        if (this.typeDivGrpBatch === 'Batch') {
          this.filteredExams = this.subjectExams.filter(exam => (exam?.batch === this.selectedBatch.batchName && exam?.division === this.selectedDivision) && (exam.uId === this.userData.uId || exam.uId === undefined)).reverse()
        }
      } else if (this.selectedExamType === 'Online Test') {
        const { exams = [] } = await apiV3.getRequest('/exam/all', {
          category: 'quick_exam',
          facultyId: this.userData.uId,
          subjectId: this.selectedSubject.subjectId,
          semId: this.selectedSemester.semId,
          batch: this.selectedBatch.batchName
        })
        this.onlineTests = exams
        // this.loading = false
        this.checkIsDeletable()
      }
      this.createShow = true
    },
    async fetchOnlineTests() {
      // this.loading = true
      this.onlineTests = []
      try {
        const objToFetch = {
          category: 'quick_exam',
          facultyId: this.userData.uId,
          subjectId: this.selectedSubject.subjectId,
          semId: this.selectedSemester.semId
        }
        if (this.selectedBatch.batch) objToFetch.batch = this.selectedBatch.batch
        if (this.selectedBatch.groupId) objToFetch.groupId = this.selectedGroup.groupId
        if (this.selectedDivision) objToFetch.division = this.selectedDivision
        const { exams = [] } = await apiV3.getRequest('/exam/all', objToFetch)
        this.onlineTests = exams
        this.checkIsDeletable()
      } catch (error) {
        console.error(error);
      }
      // this.loading = false
    },
    async getDivisionBatches() {
      this.onlineTests = []
      this.selectedBatch = ''
      this.filteredExams = []
      try {
        const objToPush = {
          instituteId: this.selectedInstitute,
          semId: this.selectedSemester.semId,
          department: this.department,
          courseYear: this.course,
          division: this.selectedDivision
        };
        this.batches =
          await this.semesterRepositoryInstance.getBatchesDetails(
            objToPush
          );
      } catch (e) {
        console.error("e", e);
      }
    },
    getGroupsOfSubjects() {
      this.onlineTests = []
      this.typeDivGrpBatch = ''
      this.isShowCreate = true
      this.filteredExams = []
      this.subjectGroups = this.selectedSubject.groupForSubject
      this.filterSubjectExams()
    },
    goToCreateExam(exam) {
      const objToPush = {
        prop_department: this.department,
        prop_course: this.course,
        prop_selectedSubject: this.selectedSubject,
        prop_typeDivGrpBatch: this.typeDivGrpBatch,
        prop_selectedDivision: this.selectedDivision
      }
      if (this.selectedGroup?.groupName) {
        objToPush['prop_selectedGroup'] = this.selectedGroup
      }
      if (this.selectedBatch?.batchName) {
        objToPush['prop_selectedBatch'] = this.selectedBatch
      }
      if (exam) {
        objToPush['prop_exam'] = exam
      }
      this.$router.push({
        name: 'activityNewCreateExam',
        params: objToPush
      })
    },
    goToAnalysis(onlineTest) {
     const analysis = true
     const editTest = true
     this.goToCreateOnlineTest(onlineTest, editTest, analysis)
    },
    goToEditOnlineTest(onlineTest) {
      const editTest = true
      this.goToCreateOnlineTest(onlineTest, editTest)
    },
    goToCreateOnlineTest(onlineTest, editTest, analysis) {
      const objToPush = {
        prop_department: this.department,
        prop_course: this.course,
        prop_selectedSubject: this.selectedSubject,
        prop_typeDivGrpBatch: this.typeDivGrpBatch,
        prop_onlineTest: onlineTest || {},
        editTest: !!editTest
      };
      if (this.selectedDivision) {
        objToPush.prop_selectedDivision = this.selectedDivision;
      }
      if (this.selectedGroup?.groupName) {
        objToPush.prop_selectedGroup = this.selectedGroup;
      }
      if (this.selectedBatch?.batchName) {
        objToPush.prop_selectedBatch = this.selectedBatch;
      } if (!editTest) {
        objToPush.disableTabs = true
        this.$store.commit("liveData/set_testId", null);
      }
      if (analysis) {
        objToPush.analysis = true;
      }
      this.$store.commit("liveData/set_selectedObjectTest", objToPush);
      this.$router.push({
        name: 'activityOnlineTest',
        params: objToPush
      })
    },
    async goToDeleteExam() {
      const exam = this.examToDelete
      try {
        if (exam?.examType) {
          await this.newExamRepositoryInstance.deleteExam({
            instituteId: this.selectedInstitute,
            semId: this.selectedSemester.semId,
            examId: exam.examId
          })
          showStatus("Successfully deleted the assignment.", 2000, 'success', this);
          await this.getExams()
          this.filterSubjectExams()
          if (this.typeDivGrpBatch === 'Division') {
            this.filterDivAssignments()
          }
          if (this.typeDivGrpBatch === 'Group') {
            this.filterGroupAssignments()
          }
          if (this.typeDivGrpBatch === 'Batch') {
            this.filterBatchAssignments()
          }
        } else if (exam?.category) {
          const examDetails = {}
          examDetails.examId = exam._id
          examDetails.questions = exam?.questions || { A: [] }
          const deletedTest = await apiV3.deleteRequest("/exam/delete", examDetails);
          console.log('deletedTest', deletedTest);
          showStatus("Successfully deleted the online test.", 2000, 'success', this);
          await this.fetchOnlineTests()
        }
      } catch (e) {
        console.error("e", e);
      }
      this.showModal = false
    }
  }
};
</script>

<style scoped src="./activityNewAssignments.css"></style>
